import axios from 'axios'
import router from '../router'
import { getCountryByHost } from './locale'

const api = axios.create({
  baseURL: getCountryByHost().api
})

const login = 'login'

api.interceptors.request.use((config) => {
  let json = localStorage.getItem('auth')
  if (json === null) {
    return config
  }

  try {
    let auth = JSON.parse(json)
    config.headers['Authorization'] = auth.token_type + ' ' + auth.access_token
  } catch (e) {
    //
  }

  return config
})

api.interceptors.response.use(
  function (response) {
    return response
  },

  function (error) {
    if (error.response && error.response.status === 401) {
      if (router.currentRoute.name !== login) {
        router.push({name: login, params: {from: 'request'}})
      }

      return
    }

    return Promise.reject(error)
  }
)

export default api



//////////////////
// WEBPACK FOOTER
// ./src/lib/api.js
// module id = 328
// module chunks = 1